// extracted by mini-css-extract-plugin
export var page = "pagePublish-module--page--5bDWg";
export var icons = "pagePublish-module--icons--x0k-o";
export var d1 = "pagePublish-module--d1--+hwjG";
export var d2 = "pagePublish-module--d2--7xRTY";
export var d3 = "pagePublish-module--d3--QRT2Z";
export var flexTop = "pagePublish-module--flexTop--ArnZ3";